// src/firebaseConfig.ts
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getMessaging } from 'firebase/messaging'
import { getFirestore } from 'firebase/firestore'
import { getPerformance } from 'firebase/performance'

const firebaseConfig = {
  apiKey: 'AIzaSyBTl-XPFMPjXREFW5CJZuonVkkbmfLmJeM',
  authDomain: 'starsavers-83c87.firebaseapp.com',
  projectId: 'starsavers-83c87',
  storageBucket: 'starsavers-83c87.firebasestorage.app',
  messagingSenderId: '670225065769',
  appId: '1:670225065769:web:49220acba541b315e57938',
  measurementId: 'G-M88TZM3VGD',
}

const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)
const messaging = getMessaging(app)
const db = getFirestore(app)
const perf = getPerformance(app)

export { app, analytics, messaging, db, perf }
